import { useCallback, useEffect, useState } from 'react';

interface IUseAutoResizeTextAreaProps {
  resizeHeightToValue: string;
  textAreaToResize: HTMLTextAreaElement | null;
  value?: string;
}

const useAutoResizeTextArea = ({
  resizeHeightToValue,
  textAreaToResize,
  value: textAreaValue,
}: IUseAutoResizeTextAreaProps) => {
  const [textAreaHeight, setTextAreaHeight] = useState('0');
  const [recalculateTextAreaHeight, setRecalculateTextAreaHeight] = useState(false);
  useEffect(() => {
    setTextAreaHeight(resizeHeightToValue);
  }, [resizeHeightToValue]);

  useEffect(() => {
    if (!recalculateTextAreaHeight || !textAreaToResize) {
      return;
    }
    setTextAreaHeight(`${textAreaToResize.scrollHeight}px`);
    setRecalculateTextAreaHeight(false);
  }, [recalculateTextAreaHeight, textAreaToResize]);

  const handleOnChangeTextAreaValue = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (!textAreaToResize) {
        return;
      }
      const prevLength = textAreaValue?.length || 0;
      const currentLength = event.target.value.length;

      let newTextAreaHeight = 0;

      if (currentLength >= prevLength) {
        newTextAreaHeight = Math.max(textAreaToResize.scrollHeight, textAreaToResize.getBoundingClientRect().height);
      }

      setTextAreaHeight(`${newTextAreaHeight}px`);

      if (event.target.value !== '' && currentLength < prevLength) {
        setRecalculateTextAreaHeight(true);
      }
    },
    [textAreaToResize, textAreaValue],
  );

  return {
    handleOnChangeTextAreaValue,
    textAreaHeight,
  };
};

export default useAutoResizeTextArea;
